import React, { useState, useEffect, useContext,useCallback } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import CarnivalForm from './createDuplicateCarnivalForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import 'react-toastify/dist/ReactToastify.css';
import {createDuplicateHelpdesk} from "../../../../services/redux/brandActivtion/conductCamp/action";

const AddDuplicateHelpdesk = ({
  match,
  history,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  createDuplicateHelpdesk,
  getHelpdeskDataForUpdation,
  carnivalData,
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };

  //For Getting Carnival Data
  const getCarnivalData = useCallback(async () => {
    if (match?.params?.id) {
      setIsLoading(true);
      await getHelpdeskDataForUpdation(match?.params?.id);
      setIsLoading(false);
    }
  }, [getHelpdeskDataForUpdation, match?.params?.id]);

  useEffect(() => {
    getCarnivalData();
  }, [getCarnivalData]);


  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    if (meetingDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      toast.error('Please fill Start & End Date & time.');
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        const res = await createDuplicateHelpdesk(meetingDetails);
        if (res?.data.saved == 1) {
          setIsModal(true);
        } else {
            toast.error('Carnival already exists within given dates!');
        }
      })();
    }
  };

  const handleModalHide2 = () => {
    // setIsInfraIdMissingModal(false);
    history.push(`${baseUrl}/brand-activation/helpdesk`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.scheduleHelpdesk}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.scheduleHelpdesk}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/helpdesk`}
    >
      <CarnivalForm
        handleValue={handleForm}
        documentUploadUrl={documentUploadUrlPublic}
        documentUrlData={documentUrlDataPublic}
        prefilledData={carnivalData}
        isUpdate
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide2}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.helpdeskSuccess}</h5>
          <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
            {localization.goToHelpdeskListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      
    </Layout>
  );
};

AddDuplicateHelpdesk.propTypes = {};

export default AddDuplicateHelpdesk;
